export default __webpack_public_path__ + "static/media/office3.af5ec5bb.jpg";